@if (mediaState(); as mediaState) {
    @let isOverrideVisible =
        mediaState.activeTab === tabType.Video && !mediaState.videoEvent && !mediaState.pendingEsport && mediaState.videoDropdownEvents.length;
    <div class="event-details-column">
        <ds-card
            class="media-card-container"
            msThemedCard
            [themeCardElevated]="themeCardElevated"
            [themeBorder]="themeBorder"
            [class.empty-media-visible]="isOverrideVisible"
            [elevated]="true"
            [border]="true">
            <ds-accordion
                msThemedAccordion
                variant="surface-low"
                [themedAccordionVariant]="themedAccordionVarient"
                [withCard]="true"
                [open]="!mediaState.collapsed"
                (openedChange)="panelToggled(mediaState.collapsed)">
                <ds-accordion-header
                    class="options-panel"
                    interactive
                    [class.custom-toggle-hover-color]="!isCustomHover"
                    [class.media-toggle-no-hover-color]="noHoverToggleBtn"
                    [class.remove-header-bottom-radius]="!mediaState.collapsed">
                    <div slot="start">
                        <div slot="title">{{ sitecore.media.Title }}</div>
                    </div>

                    <div slot="end">
                        <ms-media-tab-bar [tabs]="mediaState.tabs" (select)="tabSelected($event, mediaState)" />
                        @if (!isEpcotEnabled) {
                            <ds-divider vertical="true" />
                        }
                    </div>

                    <span class="media-toggle-btn" *dsAccordionTrigger>
                        <vn-icon size="22" [name]="mediaState.collapsed ? 'theme-down' : 'theme-up'" />
                    </span>
                </ds-accordion-header>

                <ng-template #content>
                    @if (!isEpcotEnabled) {
                        <ds-divider />
                    }
                    <div
                        id="mediaContainer"
                        class="content-container media-container"
                        aria-haspopup="true"
                        [@toggleAnimation]="{ value: undefined, params: { mediaHeight: mediaHeight + 'px' } }">
                        @if (isExpandedMediaEnabled && !mediaState.videoPlaying) {
                            <div
                                class="media-expander"
                                [ngClass]="{ 'media-expander--visible': deviceService.isTablet }"
                                [msClassAutoRemove]="'media-expander--mobile-expand'"
                                [msClassAutoRemoveTime]="EXPAND_BUTTON_FADE_TIME"
                                (click)="toggleExpand(!mediaState.isExpanded)"
                                [(msClassAutoRemoveIsClassVisible)]="isMobileExpand">
                                <span class="media-fullscreen">
                                    <vn-icon size="15" [name]="mediaState.isExpanded ? 'theme-fullscreen-exit' : 'theme-fullscreen'" />
                                </span>
                            </div>
                        }
                        @switch (mediaState.activeTab) {
                            @case (tabType.Video) {
                                <div class="event-selector-container">
                                    <ms-event-selector [eventsList]="mediaState.videoDropdownEvents" [selectedEventId]="mediaState.videoEventId" />
                                    <ms-video-pin
                                        [isPinned]="mediaState.videoPinned"
                                        [disabled]="!mediaState.pinEnabled"
                                        (toggle)="togglePin(mediaState.videoPinned)" />
                                    @if (mediaState.videoUnpinInfoVisible) {
                                        <ms-unpin-info />
                                    }
                                </div>
                                <div
                                    class="video-container"
                                    [ngClass]="getBackground(mediaState, tabType.Video)"
                                    [ngStyle]="background().videoBg"
                                    [style.height]="streamingMessageHeight">
                                    @if (mediaState.videoEvent && (!mediaState.pendingEsport || mediaState.videoPinned)) {
                                        <ng-container *msComponentProxy="videoStreamComponent" />
                                    }
                                    @if (isOnEventDetails && mediaState.pendingEsport && !mediaState.videoEvent) {
                                        <ms-video-stream-button disabled [event]="mediaState.pendingEsport!" [isEventPending]="true" />
                                    }
                                </div>
                                @if (!mediaState.videoEvent && !mediaState.pendingEsport) {
                                    <ms-empty-media
                                        [isEventSelected]="mediaState.isEventDetailPage || mediaState.hasEventOnMedia"
                                        [emptyList]="mediaState.videoDropdownEvents.length < 1"
                                        [isEventLive]="mediaState.isEventLive" />
                                }
                            }
                            @case (tabType.Animation) {
                                <div class="animation" [ngClass]="getBackground(mediaState, tabType.Animation)" [ngStyle]="background().videoBg">
                                    @if (!isAnimationDisabled()) {
                                        @if (
                                            !mediaState.isAnimationAvailable &&
                                            mediaState.animationEvent &&
                                            mediaState.animationEvent.runningBallDataId
                                        ) {
                                            <ms-match-simulation
                                                [runningBall]="mediaState.animationEvent!.runningBallDataId!"
                                                [awayTeam]="mediaState.animationEvent!.participants[1].name"
                                                [homeTeam]="mediaState.animationEvent!.participants[0].name"
                                                [inColumn]="true" />
                                        } @else {
                                            <ng-container *msComponentProxy="animationComponent" />
                                        }
                                    } @else {
                                        <ms-empty-media [emptyList]="true" />
                                    }
                                </div>
                            }
                            @case (tabType.Stats) {
                                <div [ngClass]="getBackground(mediaState, tabType.Stats)" [ngStyle]="background().statsBg">
                                    @if (mediaState.statisticsEvent) {
                                        <ndc-dynamic
                                            [ndcDynamicComponent]="eventStatisticsComponent$ | async"
                                            [ndcDynamicInputs]="{ event: mediaState.statisticsEvent!, inColumn: true }"
                                            [ndcDynamicOutputs]="eventStatisticsComponentOutputs" />
                                    }
                                </div>
                            }
                        }
                    </div>
                </ng-template>
            </ds-accordion>
        </ds-card>
    </div>
}
